<ng-container [ngSwitch]="mainService.getShopPortalLayoutKind()">
    <app-promotion-detail-boxed-layout-component *ngSwitchDefault></app-promotion-detail-boxed-layout-component>
    <app-promotion-detail-scroll-layout-component *ngSwitchCase="1"></app-promotion-detail-scroll-layout-component>
</ng-container>